import { render, staticRenderFns } from "./OtherPlansMobile.vue?vue&type=template&id=925b1058"
import script from "./OtherPlansMobile.vue?vue&type=script&lang=js"
export * from "./OtherPlansMobile.vue?vue&type=script&lang=js"
import style0 from "./OtherPlansMobile.vue?vue&type=style&index=0&id=925b1058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports